<template>
  <div class="long-readable-text">
    <div
      v-if="!isExpanded"
      class="collapsed-text"
      :style="Object.assign({}, collapsedStyle, {'--fade-color': fadeColor})"
      @click="isExpanded = true"
      style="cursor: pointer;"
    >
      <slot v-if="$slots.default"></slot>
      <div v-else v-html="text"></div>
    </div>
    <a
      class="d-block mt-0" href="#" v-if="!isExpanded"
      @click.prevent="isExpanded = true"
    >
      Read more
    </a>
    <div
      v-if="isExpanded"
      class="mb-0"
      :class="{'html-pre-wrap': withPreWrap}"
    >
      <slot v-if="$slots.default"></slot>
      <div v-else v-html="text"></div>
    </div>
    <a
      v-if="isExpanded"
      class="d-block mt-2"
      href="#"
      @click.prevent="isExpanded = false"
    >
      Read less
    </a>
  </div>
</template>

<script>
/**
 * Variant of LongText; same styling, but slightly different behaviour.
 * The difference is: in its collapsed form, it has a fixed height in px. (instead of truncating the text after X characters)
 *
 * This component is notably helpful for showing a body of streaming text.
 * (because this way, your page layout won't be "jumping around" while the text is streaming in)
 */
export default {
  name: 'LongTextFixedHeight',
  props: {
    text: String,
    withPreWrap: Boolean,
    minHeight: { // Min height in collapsed form, in px
      type: Number,
      default: 80
    },
    fadeColor: { // Fade truncated text into this background color
      type: String,
      default: '#fff'
    }
  },
  data () {
    return {
      isExpanded: false
    }
  },
  computed: {
    collapsedStyle () {
      return {
        minHeight: this.minHeight + 'px',
        maxHeight: this.minHeight + 'px',
        overflow: 'hidden'
      }
    }
  },
  methods: {
    collapse () {
      this.isExpanded = false
    },
    expand () {
      this.isExpanded = true
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsed-text {
  overflow: hidden;
  position: relative;
}

.collapsed-text::after {
  content: '';
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 2em;
  background: linear-gradient(to bottom, rgba(255,255,255,0), var(--fade-color, #fff) 90%);
  pointer-events: none;
}
</style>
